import { Injectable, ComponentFactoryResolver, EventEmitter, Injector, Optional } from '@angular/core';
import { BsModalService, ModalOptions } from '@farris/ui-modal';
import { ProcessSelectorComponent } from '../process-selector/process-selector.component';
import { ExcutionResponse } from '../../entity/excution-response';
import { InteractionResponse } from '../../entity/interaction-response';
import { ProcessDefinition } from '../../entity/processdefinition';
import { AssigneeInfo } from '../../entity/complete-response';
import { AssignParticipantComponent } from '../assign-participant/assign-participant.component';
import { Subject, Observable, of } from 'rxjs';
import { I18nService } from '../../runtime/services/i18n.service';

/**
 * 提交审批客户端交互服务
 */
@Injectable()
export class WFSubmiteService {

    constructor(
        private injector: Injector,
        private resolver: ComponentFactoryResolver,
        private modalService: BsModalService,
        @Optional() private i18nService: I18nService
    ) { }

    /**
     * 客户端交互处理服务端返回结果
     * @param excutionRe 提交审批服务器端返回结果
     * @param handler 处理结果回调页面
     */
    excute(excutionRe: ExcutionResponse, handler: (result: InteractionResponse) => void): void {
        const response = new InteractionResponse();
        // 无需交互
        if (excutionRe.needInteraction === false) {
            response.message = '无需交互';
            handler(response);
            return;
        }
        // 选择要提交的流程
        if (excutionRe.procDefs && excutionRe.procDefs.length > 1) {
            this.selectProcess(excutionRe.procDefs, handler);
            return;
        }
        // 指定下一步参与者
        if (excutionRe.nextFlowNodes[0].assigneeInfo) {
            this.assignee([excutionRe.nextFlowNodes[0].assigneeInfo], handler);
            return;
        }
    }

    /**
     * 处理选择流程结果
     */
    private selectProcess(prcesses: ProcessDefinition[], handler: (result: InteractionResponse) => void): void {
        const response = new InteractionResponse();
        const modalConfig: ModalOptions = {
            title: this.i18nService ? this.i18nService.getValue('static.submit.selectProcess') : '流程选择',
            width: 520,
            height: 290,
            showButtons: false,
            showMaxButton: false,
            beforeClose: (modelRef: any) => {
                handler(response);
                return of(true);
            }
        };
        const compFactory = this.resolver.resolveComponentFactory(ProcessSelectorComponent);
        const compRef = compFactory.create(this.injector);
        compRef.instance.gridData = prcesses;
        const dialog = this.modalService.show(compRef, modalConfig);
        compRef.instance.subscribe().subscribe(val => {
            response.processDefinitionId = val;
            dialog.close();
        }, err => {
            response.message = err;
            dialog.close();
        });
    }
    /**
     * 处理指定下一步人员结果
     */
    private assignee(assigneeInfos: AssigneeInfo[], handler?: (result: InteractionResponse) => void) {
        const response = new InteractionResponse();
        const modalConfig: ModalOptions = {
            title: this.i18nService ? this.i18nService.getValue('static.assignee.title') : '请选择操作用户',
            width: 850,
            height: 520,
            showMaxButton: false,
            showButtons: false,
            beforeClose: (modelRef: any) => {
                handler(response);
                return of(true);
            }
        };
        const compFactory = this.resolver.resolveComponentFactory(AssignParticipantComponent);
        const compRef = compFactory.create(this.injector);
        compRef.instance.assigneeInfo = assigneeInfos;
        const dialog = this.modalService.show(compRef, modalConfig);
        compRef.instance.subscribe().subscribe(val => {
            dialog.close();
        }, err => {
            dialog.close();
        });
    }
}
